import clsx from 'clsx'
import React from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { Icon, Input } from '../../../components'
import { addToWatchlist, removeFromWatchlist, updateWatchList } from '../../../store/conversions'

import './AllConversions.scss'

const AllConversion = ({ close }) => {
   const dispatch = useDispatch()
   const { isDarkTheme } = useSelector(state => state.theme)
   const { watchlist, conversions } = useSelector(state => state.conversions)

   const [filteredList, setFilteredList] = React.useState(conversions)

   const [query, setQuery] = React.useState('')

   React.useEffect(() => {
      if (query) {
         const term = query.toLowerCase()
         setFilteredList(
            conversions.filter(
               c =>
                  c.to.name.toLowerCase().includes(term) ||
                  c.to.unit.toLowerCase().includes(term) ||
                  c.from.unit.toLowerCase().includes(term) ||
                  c.from.name.toLowerCase().includes(term)
            )
         )
      } else {
         setFilteredList(conversions)
      }
   }, [query, setFilteredList, conversions])

   React.useEffect(() => {
      const getPairPrices = async () => {
         const coinList = ['BNB']
         let tempConversion = []
         let tempWatchlist = []
         for(let i = 0; i < coinList.length; i++) {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/token/getTokenPrice?token=${coinList[i]}`)
            tempConversion.push(response.data.data)
            tempWatchlist.push(response.data.data)
         }
         
         // dispatch(updateConversionPrices(tempConversion))
         dispatch(updateWatchList(tempWatchlist))
      }
      getPairPrices()
   }, [])

   const isInWatchlist = conversion =>
      !!watchlist.find(
         conv =>
            conv.to.unit === conversion.to.unit &&
            conv.from.unit === conversion.from.unit
      )

   const handleAction = async(conversion) => {
      if (isInWatchlist(conversion)) {
         dispatch(removeFromWatchlist({ conversion }))
      } else {
         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/token/getTokenPrice?token=${conversion['from']['unit']}`)
         let tempConversion = {
            from: {
               name: response.data.data.from.name,
               unit: response.data.data.from.unit,
               change: response.data.data.from.change,
               image: response.data.data.from.image,
            },
            to: {
               name: 'TetherUS',
               unit: 'USDT',
               change: response.data.data.to.change,
               image: response.data.data.to.image,
            },
            value: response.data.data.value,
         }
         
         dispatch(addToWatchlist(tempConversion))
      }
   }

   return (
      <div
         className={clsx(
            'AllConversions',
            isDarkTheme && 'AllConversions--dark'
         )}
      >
         <div className="AllConversions__header">
            <Input
               placeholder="Search"
               className="AllConversions__header-input"
               value={query}
               onChange={e => setQuery(e.target.value)}
               isDarkTheme={isDarkTheme}
            />
         </div>
         <div className="AllConversions__list">
            {filteredList.map((conv, index) => (
               <div className="AllConversions__list-item" key={index}>
                  <h3 className="AllConversions__list-item-text">
                     {conv.from.unit + conv.to.unit}
                  </h3>
                  <h3 className="AllConversions__list-item-text">
                     {conv.from.name + ' / ' + conv.to.name}
                  </h3>
                  <Icon
                     onClick={() => handleAction(conv)}
                     name={isInWatchlist(conv) ? 'close' : 'plus'}
                     className="AllConversions__list-item-icon"
                  />
               </div>
            ))}
         </div>
      </div>
   )
}

export default AllConversion
